import cx from "classnames";

import Slider from "rc-slider";


import "rc-slider/assets/index.css";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";
// не получиться сделать рабочий фуллскрин на IOS на 25.03.2021
// так как мы используем не только <video> тег https://developer.apple.com/forums/thread/133248
import { isIOS, isMobile } from "react-device-detect";
import { connect } from "react-redux";
import Duration from "../../components/Duration";
import { ICON_TYPE, IconButton } from "../../components/font-icons/IconButton";
import * as Actions from "../../store/actions";
import { changePlaybackRate } from "../../store/actions";
import { toggleControlsHover } from "../../store/actions/controls-visibility-actions";
import * as ControlsActions from "../../store/actions/play-actions";
import * as ReadActions from "../../store/actions/read-actions";
import * as VideoActions from "../../store/actions/video-actions";
import {
  getActiveFrame,
  getAvailableResolutions,
  getBookSubtitles,
  getBookType,
  getControlsVisibility,
  getCurrentTime,
  getFullDuration,
  getGalleryVisibility,
  getIsAudioBook,
  getIsBellEnabled,
  getIsBellHintVisibility,
  getIsDemo,
  getIsFullscreen,
  getIsPlayerReady,
  getIsPlaying,
  getIsResolutionPopupOpened,
  getIsSlideZoomed,
  getIsStarted,
  getPLAYER,
  getRealDuration,
  getSubtitlesVisibility,
  getTotalNumberOfFrames,
  getVideoResolution,
  getViewMode,
  getVolume,
} from "../../store/selectors/selectors";
import "./style.scss";

const Handle = Slider.Handle;

class PlayControls extends Component {

  timerKeyboardId;
  constructor(props) {
    super(props);
    this.state = {
      seek: 0,
      isClicked: false,
      tooltipEnabled: false,
      settingsVolOn: true,
      lastSetVolume: 0.8,
      isSettingsPopupOpened: false,
      settingsPopupType: null,
    };
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyboard);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyboard);
  }

  onSeekMouseDown = () => {
    this.setState({ isClicked: true });
  }

  onSeekMouseUp = () => {
    this.setState({ isClicked: false });
  }

  changeVideoResolution(resolution) {
    this.props.changeVideoResolution(resolution);
    this.toggleVideoSettings();
  }

  changeVideoPlaybackRate(playbackRate) {
    if (playbackRate === "Normal") playbackRate = 1;
    this.props.changePlaybackRate(playbackRate);
    this.toggleVideoSettings();
  }

  toggleVideoSettings = () => {
    this.setState((state) => ({ isSettingsPopupOpened: !state.isSettingsPopupOpened, settingsPopupType: null }));
  };

  toggleVolSettings = () => {
    if (!this.state.settingsVolOn && this.props.volume) {
      this.setState((state) => ({ lastSetVolume: this.props.volume }));
      this.props.setVolume(0);
    } else {
      if (this.state.settingsVolOn) {
        this.setState((state) => ({ lastSetVolume: this.props.volume }));
        this.props.setVolume(0);
      } else {
        this.setState((state) => ({ volume: state.lastSetVolume }));
        this.props.setVolume(this.state.lastSetVolume);
      }
      this.setState((state) => ({ settingsVolOn: !state.settingsVolOn }));
    }
  };

  onVolumeChange = volume => {
    this.props.setVolume(volume)
  }

  handleKeyboard = (event) => {

    if (event.key === 'ArrowLeft') {
      if (this.props.activeFrame === -1) return;
      this.handlePreviosPage();
    }


    if (event.key === 'ArrowRight') {
      this.handleNextPage();
    }

  }

  handleBellPress = () => {
    this.props.toggleBellPlay();
  }

  handleToggleSubtitles = () => {
    this.props.toggleSubtitilesVisibility();
  }

  handleNextFrame = () => {
    const {
      isFilm,
      PLAYER,
      currentTime,
      isAudioBook
    } = this.props;
    if (isFilm) {
      PLAYER.seekTo(currentTime + 10)
    } else if (isAudioBook){
      PLAYER.seekTo(currentTime + 20)
    } else {
      this.props.setNextFrame();
    }
  }

  handlePreviosFrame = () => {
    const {
      isFilm,
      PLAYER,
      currentTime,
      isAudioBook
    } = this.props;
    if (isFilm) {
      PLAYER.seekTo(currentTime - 10)
    } else if (isAudioBook){
      PLAYER.seekTo(currentTime - 20)
    } else {
      this.props.setPreviosFrame();
    }
  }

  handleNextPage = () => {
    const {
      isFilm,
      isAudioBook
    } = this.props;
    if (isAudioBook || isFilm) {
      this.handleNextFrame();
    } else this.props.nextPage();
  }

  handlePreviosPage = () => {
    const {
      isFilm,
      isAudioBook
    } = this.props;
    if (isAudioBook || isFilm) {
      this.handlePreviosFrame()
    } else this.props.prevPage();
  }

  handleRepeatCurrentFrame = () => {
    this.props.repeatCurrentFrame();
  }

  handleSeekChange = (val) => {
    this.props.videoSeekChange(val);
  }

  getSettingsPopup = () => {
    const { settingsPopupType } = this.state;
    const isResolutionsAvailable = !this.props.isAudioBook && this.props.availableResolutions;
    if (!settingsPopupType && isResolutionsAvailable) {
      return (
        <div className="settings-popup">
          <div className="settings-popup__row settings-popup__row_active"
            onClick={()=>this.setState(() => ({ settingsPopupType: "resolution" }))}
          >
            <div>Resolution</div>
            <div>{this.props.videoResolution} &gt;</div>
          </div>
          <div className="settings-popup__row settings-popup__row_active"
            onClick={()=>this.setState(() => ({ settingsPopupType: "playback-rate" }))}
          >
            <div>Playback speed</div>
            <div>{this.props.playbackRate} &gt;</div>
          </div>
        </div>
      );
    }
    if (settingsPopupType === "resolution") {
      return (
        <div className="settings-popup">
          <div className="settings-popup__row settings-popup__row_active"
            onClick={()=>this.setState(() => ({ settingsPopupType: null }))}>
            &lt; Resolution
          </div>
          {this.renderResolutionsList()}
        </div>
      );
    }
    return (
      <div className="settings-popup">
        <div className={"settings-popup__row " + (isResolutionsAvailable ? "settings-popup__row_active" : "")}
          onClick={()=>this.setState(() => ({ settingsPopupType: null }))}>
          {isResolutionsAvailable ? '<' : ''} Playback speed
        </div>
        {this.renderSpeedList()}
      </div>
    )
  };

  renderResolutionsList() {
    const {
      videoResolution,
      availableResolutions
    } = this.props;

    return Object.entries(JSON.parse(availableResolutions)).map(([key, streamSize]) => {
      let resolution = parseInt(key, 10);
      return (

        <div className="settings-popup__control" key={key}>
          <div
            className={`settings-popup__link ${videoResolution === resolution ? ICON_TYPE.CHECK : ''}`}
            onClick={() => this.changeVideoResolution(resolution)}
          >
            {key}
          </div>
        </div>
      );
    });
  }

  renderSpeedList() {
    const availableRates = [0.25, 0.5, 0.75, "Normal", 1.25, 1.5, 1.75, 2];

    return availableRates.map((rate) => {
      return (
        <div className="settings-popup__control" key={rate}>
          <div
            className={`settings-popup__link ${this.props.playbackRate === rate ||
            (rate === "Normal" && this.props.playbackRate === 1) ? ICON_TYPE.CHECK : ""}`}
            onClick={() => this.changeVideoPlaybackRate(rate)}
          >
            {rate}
          </div>
        </div>
      );
    });
  }

  getVideoPlayerControls() {
    const {
      viewMode,
      volume,
      activeFrame,
      isPlaying,
      isControlsHidden,
      totalNumberOfFrames,
      isGalleryShown,
      isSliderView,
      isFullscreen,
      isStarted,
      isBellHitnVisible,
      durationFull,
      subtitlesVisibility,
      currentTime,
      isAudioBook,
      isFilm,
    } = this.props;

    const { isSettingsPopupOpened } = this.state;

    let isHidden = isGalleryShown || isControlsHidden;
    const playMarkerValue = currentTime / durationFull;

    const volumeIconType = () => {
      if (!volume) {
        return ICON_TYPE.VOLUME_OFF;
      } else {
        if (volume >= 0.5) {
          return ICON_TYPE.VOLUME;
        } else {
          return ICON_TYPE.VOLUME_MEDIUM;
        }
      }
    };


    const toolTipHandle = (props) => {
      if (this.props.isPlayerReady && !this.props.isControlsHidden) {
        const { value, dragging, index, ...restProps } = props;


        return (
          <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={
              <Duration seconds={this.props.currentTime} frmt="mm" />
            }
            visible={!isFullscreen && (dragging && !this.props.isControlsHidden || this.state.tooltipEnabled === true)}
            placement="top"
            key={index}

          >
            <Handle
              value={value}
              {...restProps}
            />
          </Tooltip>
        );
      }
    };

    return (
      <div
        className={
          cx(
            `player-controls-container`,
            { 'is-hidden': isHidden }
          )
        }
        onMouseEnter={() => { !isMobile && this.props.toggleControlsHover(true) }}
        onMouseLeave={() => { !isMobile && this.props.toggleControlsHover(false) }}
      >
        <div className="duration-wrapper">
          <div className="duration-container">
            <div className="time current-duration">
              <p>
                <Duration seconds={currentTime} />
              </p>
            </div>
            <div
              className="slider-wrapper"
              onMouseOver={(e) => { this.setState({ tooltipEnabled: true }) }}
              onMouseOut={(e) => { this.setState({ tooltipEnabled: false }) }}
            >
              <Slider
                min={0}
                step={1 / (durationFull > 0 ? durationFull : 1)}
                max={1}
                value={playMarkerValue}
                onChange={this.handleSeekChange}
                onAfterChange={this.onSeekMouseUp}
                onBeforeChange={this.onSeekMouseDown}
                handle={toolTipHandle}
              />
            </div>
            <div className="time full-duration">
              <p>
                <Duration seconds={durationFull} />
              </p>
            </div>
          </div>
        </div>

        <div className="controls-wrapper">
          <div className="sound-controls">

            <div className="control" onClick={this.toggleVolSettings}>
              <IconButton type={volumeIconType()} />
            </div>

            <Slider
              className="cnb-video-player-volume-control volume-control"
              min={0}
              max={1}
              step={0.02}
              value={volume}
              onChange={this.onVolumeChange}
            />

          </div>
          <div className="play-block">
            <div className="control frame-number">
              { isAudioBook
                ? '-20s'
                :(activeFrame > 0 ? activeFrame : "")}
            </div>

            <div className="control">
              <IconButton
                type={ICON_TYPE.VIDEO_PREVIOUS}
                onClick={this.handlePreviosFrame}
                hoverEnabled={true}
              />
            </div>

            <div className="control">
              {isPlaying
                ? <IconButton
                  type={ICON_TYPE.VIDEO_PAUSE}
                  onClick={() => this.props.togglePlay(false)}

                />
                : <IconButton
                  type={ICON_TYPE.VIDEO_PLAY}
                  onClick={this.props.waitingForAction ? undefined : () => this.props.togglePlay(true)}
                />
              }
            </div>

            {!isFilm && !isAudioBook &&
            <div className="control repeat">
                <IconButton
                  type={ICON_TYPE.VIDEO_REPEAT}
                  hoverEnabled={true}
                  onClick={this.handleRepeatCurrentFrame}
                />
              </div>
            }
            <div className="control">
              <IconButton
                type={ICON_TYPE.VIDEO_NEXT}
                onClick={this.props.waitingForAction ? undefined : this.handleNextFrame}
                hoverEnabled={true}
              />
            </div>

            <div className="control frame-number">
              {
              isAudioBook
              ? '+20s'
              : (totalNumberOfFrames > 0 ? totalNumberOfFrames : "")
              }
            </div>
          </div>

          <div className="settings-block">

            {(isSliderView && viewMode !== 'text') &&
              <div className="control">
                <IconButton
                  type={ICON_TYPE.BELL}
                  activeState={this.props.isBellEnabled}
                  onClick={this.handleBellPress}
                />
              </div>
            }
            {this.props.bookSubtitles &&
              <div className="control">
                <IconButton
                  type={ICON_TYPE.SUBTITLE}
                  activeState={subtitlesVisibility}
                  onClick={this.handleToggleSubtitles}
                />
              </div>
            }
            <div className="control gear-control">
              <IconButton
                type={isSettingsPopupOpened ? ICON_TYPE.SETTINGS_PRESSED : ICON_TYPE.SETTINGS}
                onClick={this.toggleVideoSettings}
              />
              {isSettingsPopupOpened && this.getSettingsPopup()}
            </div>
            <div className={cx('control', {
              'is-hidden': isIOS,
            })}>
              <IconButton
                type={isFullscreen ? ICON_TYPE.EXIT_FULL_SCREEN : ICON_TYPE.FULL_SCREEN}
                onClick={this.props.onClickFullscreen}
              />
            </div>
          </div>
          <div
            className={cx('settings-popup__overlay', { 'hidden': !isSettingsPopupOpened })}
            onClick={this.toggleVideoSettings}
          />

        </div>
        <div
          className={cx(
            'sound-ring-message',
            { 'hidden': !(isSliderView && (!isStarted || playMarkerValue) && isBellHitnVisible) }
          )}
        >
          Sound notification for picture changing&nbsp;is&nbsp;{this.props.isBellEnabled ? 'ON' : 'OFF'}
        </div>
      </div>
    );
  }

  getTextPlayerControls() {
    const {
      activeFrame,
      totalNumberOfFrames,
      hidden,
      isGalleryShown,
      isDemo,
      textReader,
      viewMode,
      isFullscreen
    } = this.props;

    const isLastFrame = totalNumberOfFrames === activeFrame;
    const isVideoMode = viewMode !== 'text';
    const isTextMode = viewMode === 'text';
    let isLast = isLastFrame && (!isDemo && (isVideoMode || (isTextMode && textReader.textAreaPage >= textReader.textAreaPages)));
    let isFirst = activeFrame <= 0;

    let isHidden = isGalleryShown || hidden;


    return (
      <div className="reading-controls">
        <div
          className={cx('navigation-block', {
            'is-hidden': isGalleryShown
          })}
        >
          <div
            className={cx(
              'control',
              { 'disabled': isFirst }
            )}
          >
            <IconButton
              type={ICON_TYPE.BACKWARD}
              onClick={this.props.waitingForAction ? undefined : this.handlePreviosPage}
            />
          </div>
          <div className="control frame-counter">
            <p>
              {activeFrame > 0 ? activeFrame + "" : "0 "}
              /
              {totalNumberOfFrames}
            </p>
          </div>
          <div
            className={cx(
              'control',
              { 'disabled': isLast }
            )}
          >
            <IconButton
              type={ICON_TYPE.FORWARD}
              onClick={this.props.waitingForAction ? undefined : this.handleNextPage}
            />
          </div>
        </div>

        <div
          className={cx('reading-controls-wrapper', {
            'is-hidden': isHidden
          })}
          onMouseEnter={() => { !isMobile && this.props.toggleControlsHover(true) }}
          onMouseLeave={() => { !isMobile && this.props.toggleControlsHover(false) }}
        >

          <IconButton
            type={isFullscreen ? ICON_TYPE.EXIT_FULL_SCREEN : ICON_TYPE.FULL_SCREEN}
            onClick={this.props.onClickFullscreen}
            className={cx('read-fullscreen-button', {
              'is-hidden': isIOS
            })}
          />


        </div>
      </div>
    );
  }

  render() {
    const { viewMode } = this.props;

    if (viewMode !== 'text') {
      return this.getVideoPlayerControls();
    } else {
      return this.props.isSlideZoomed ? null : this.getTextPlayerControls();
    }
  }
}

PlayControls.defaultProps = { visibility: true };

const mapStateToProps = state => {
  const { book, textReader, } = state;
  const bookType = getBookType(state);
  const isSlideZoomed = getIsSlideZoomed(state);
  const controlsVisibility = getControlsVisibility(state);
  return {
    viewMode: getViewMode(state),
    isDemo: getIsDemo(state),
    isControlsHidden: !controlsVisibility || isSlideZoomed,
    isSlideZoomed: getIsSlideZoomed(state),
    totalNumberOfFrames: getTotalNumberOfFrames(state),
    isSliderView: (bookType === 'photo-illustrated book'),
    isFilm: (bookType === 'film'),
    availableResolutions: getAvailableResolutions(state),
    isGalleryShown: getGalleryVisibility(state),
    videoResolution: getVideoResolution(state),
    isFullscreen: getIsFullscreen(state),
    isStarted: getIsStarted(state),
    isResolutionPopupOpened: getIsResolutionPopupOpened(state),
    textReader,
    activeFrame: getActiveFrame(state),
    PLAYER: getPLAYER(state),
    volume: getVolume(state),
    realDuration: getRealDuration(state),
    durationFull: getFullDuration({ book }),
    currentTime: getCurrentTime(state),
    isPlaying: getIsPlaying(state),
    subtitlesVisibility: getSubtitlesVisibility(state),
    isBellEnabled: getIsBellEnabled(state),
    isBellHitnVisible: getIsBellHintVisibility(state),
    isPlayerReady: getIsPlayerReady(state),
    bookSubtitles: getBookSubtitles(state),
    isAudioBook: getIsAudioBook(state),
    waitingForAction: state.videoPlayerState.waitingForAction,
    playbackRate: state.app.playbackRate
  }
};

const cationCreators = {
  ...Actions,
  ...VideoActions,
  ...ControlsActions,
  ...ReadActions,
  toggleControlsHover,
  changePlaybackRate
}

export default connect(mapStateToProps, cationCreators)(PlayControls)


// WEBPACK FOOTER //
// ./src/containers/play-controls/PlayControls.jsx